import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import VocoContext from './contexts/VocoContext'
import Message from './containers/Message'
import ModuleInjections  from './voco-bootstrap'
import config from "./config"
import ChiModuleLoader from './utils/chiModuleLoader'
import { resolveThreeRadical, camelCase } from 'content-hosting-interface-helpers/helpers'
import packageJson from './package.json'

function defaultFn(modules, config, el, message) {

  ReactDOM.render(
    <React.StrictMode>
      <VocoContext.Provider value={{modules : modules, device: modules.device, navigation : modules.navigation, realDevice: modules.realDevice, config : config, message: message, ioc: modules.ioc}}>
        <Message />
      </VocoContext.Provider>
    </React.StrictMode>,
    el
  );
}

let scafoldingElement = document.getElementById("fc80d7f7-867d-49d4-90d1-a22fd6922a60")

if (scafoldingElement) {
  let exampleConfig = resolveThreeRadical(packageJson.threeRadical.development, 'threeRadical', true)
  let schemeId = config.schemeId
  let tacticId= config.tacticId
  let serverUrl = config.serverUrl
  ModuleInjections.getNewInjectionInstance(schemeId, serverUrl).then(function(ioc) {
    let acceptDevice = null
    let rejectDevice = null
    let __startTime = Date.now()

    var threeRadicalDeviceReady = new Promise(function (accept, reject) {
        acceptDevice = accept
        rejectDevice = reject
    })

    ioc.run(
      "3r/login-api/login/register",
      {
          externalId : Date.now() + "-3r@testing.com",
      },
      null,
      false,
      function () {
          return true
      }
    ).then(function (regData) {
        ioc.call(["3r/Device"], function (device) {
            acceptDevice(window.Device)
        })
        console.log("Registered: ", Date.now() - __startTime)
        console.log(regData)
    }).catch(function (e) {
        rejectDevice(e)
    })

    threeRadicalDeviceReady.then(function (Device) {
      let message = Device.info.messages.filter(m => m.systemId == tacticId)[0]
  
      let chiModules = ChiModuleLoader.getChiModules(message, window.Device, ioc)
  
      defaultFn(
        chiModules,
        exampleConfig,
        scafoldingElement,
        message
      )
    })    
  })

  reportWebVitals();
} else {
  window[camelCase(packageJson.name)] = {
    default : defaultFn
  }
}

export default defaultFn

